export class VehicleModelState {

  brandName: string;
  modelName: string;
  fuelName: string;
  enginePower: string;

  constructor() {
  }
}
